export default "Optimisation TURPE site industriel — Acheminement HTA | Solution Éco France";
